/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import { Menu, Dropdown } from "antd";
import "./styles.css";
import { DownOutlined } from "@ant-design/icons";
import zobu from "../../utils/images/zobu.svg";
import logoutIcon from "../../utils/images/logout.svg";
import AuthContext from "../../contexts/auth";
import Avatar from "../avatar";

const User = () => {
  const { user, logout } = useContext(AuthContext);

  const signout = e => {
    logout();
  };

  const menu = (
    <Menu>
      <Menu.Item key="0">
        <a href="https://profile.zostel.com/" target="_blank">
          Profile
        </a>
      </Menu.Item>
      <Menu.Item key="1">
        <a href="https://zobu.zostel.com/" target="_blank">
          Zobu
        </a>
      </Menu.Item>
      <Menu.Item key="2">
        <a href="https://maps.zostel.com/" target="_blank">
          Maps
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3" onClick={() => signout()}>
        <img className="logout" src={logoutIcon} alt="logout" />
        Sign out
      </Menu.Item>
    </Menu>
  );

  return (
    user && (
      <Dropdown overlay={menu} trigger={["click"]}>
        <a onClick={e => e.preventDefault()}>
          <Avatar className="avatar" svg={user.avatar_url || zobu} />
          <span className="name">{user.first_name}</span>
          <DownOutlined className="arrow" />
        </a>
      </Dropdown>
    )
  );
};

export default User;
